import React from "react";
import { useNavigate } from "react-router-dom";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import Card from "@mui/material/Card";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDButton from "components/MDButton";
import { useTheme } from "@mui/material/styles";
import SchoolIcon from '@mui/icons-material/School';

function TutorialOfferPopup({ open, onClose }) {
  const theme = useTheme();
  const navigate = useNavigate();
  
  const handleGoToTutorials = () => {
    navigate('/fx-dashboard/tutorials');
    onClose(); // Triggers Firestore update in Dashboard.js
  };
  
  const handleDecline = () => {
    onClose(); // Triggers Firestore update in Dashboard.js
  };
  
  return (
    <Dialog 
      open={open} 
      onClose={handleDecline}
      PaperProps={{
        style: { 
          backgroundColor: theme.palette.background.default,
          boxShadow: 'none',
          maxWidth: '500px'
        }
      }}
    >
      <DialogContent>
        <Card sx={{ 
          position: 'relative',
          overflow: 'hidden',
          backgroundColor: 'rgba(33, 150, 243, 0.1)',
          border: '2px solid #2196f3',
          borderRadius: '8px',
          boxShadow: '0 4px 20px rgba(0,0,0,0.14)',
        }}>
          <MDBox p={3} textAlign="center">
            <MDBox 
              display="flex" 
              justifyContent="center" 
              alignItems="center"
              mb={2}
            >
              <SchoolIcon 
                sx={{ 
                  fontSize: '2.5rem', 
                  color: '#2196f3'
                }} 
              />
            </MDBox>
            <MDTypography variant="h5" color="info" fontWeight="bold" mb={2}>
              Welcome to FX Bullsheet!
            </MDTypography>
            <MDTypography variant="body2" mb={3}>
              Would you like to check out our tutorials to learn how to use all the features and get the most out of the platform? You will not see this message again after this.
            </MDTypography>
            <MDBox display="flex" justifyContent="space-between" mt={3}>
              <MDButton
                variant="text"
                color="dark"
                onClick={handleDecline}
                sx={{ width: '45%' }}
              >
                Skip for Now
              </MDButton>
              <MDButton
                variant="gradient"
                color="info"
                onClick={handleGoToTutorials}
                sx={{ width: '50%' }}
              >
                View Tutorials
              </MDButton>
            </MDBox>
          </MDBox>
        </Card>
      </DialogContent>
    </Dialog>
  );
}

export default TutorialOfferPopup;